import { render, staticRenderFns } from "./OrderItemSpecs.vue?vue&type=template&id=4abd51be&scoped=true"
import script from "./OrderItemSpecs.vue?vue&type=script&lang=js"
export * from "./OrderItemSpecs.vue?vue&type=script&lang=js"
import style0 from "./OrderItemSpecs.vue?vue&type=style&index=0&id=4abd51be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abd51be",
  null
  
)

export default component.exports